<template>
    <div class="doc_sb_edit p-3">
        <div class="template p-3">
            <organization_select
                @on_organization_set="set_org_id"
                :active_id="parseInt(cur_tov_id)">
            </organization_select>
        </div>
        
        <div class="template p-3">
            <department_select
                :active_org_id="parseInt(cur_tov_id)"
                @on_department_set="set_dep_id"
                :active_id="parseInt(cur_dep_id)">
            </department_select>
        </div>
        
        <div class="template p-3">
            <div class="form-group">
                <label class="form-label" for="payment_online">
                    Виберiть з випадаючого списку стан*
                </label>
                <div>
                    <b-form-radio-group
                        id="btn-radios-1"
                        v-model="doc_rating"
                        button-variant="outline-primary"
                        :options="rating_variants"
                        name="radios-btn-default"
                        buttons
                    ></b-form-radio-group>
                </div>
            </div>
        </div>
        
        <div class="template p-3">
            <label class="form-label" for="payment_online">
                Введiть коментар
            </label>
            
            <div class="select_step">
                <b-textarea v-model="doc_comment" :rows="10"></b-textarea>
            </div>
        </div>
    </div>
</template>


<script>
import Organization_select from "../../../../shared/select/organization_select.vue";
import Department_select from "../../../../shared/select/department_select.vue";


export default {
    name: "doc_general",
    components: {Department_select, Organization_select},
    props : {
        doc : {
            type : Object,
        }
    },
    
    methods : {
        set_org_id(org_id) {
            this.$emit('doc_change',{
                'type' : 'tov_id',
                'val'  : org_id
            });
            
            this.set_dep_id(0);
        },
        
        set_dep_id(dep_id) {
            this.$emit('doc_change',{
                'type' : 'dep_id',
                'val'  : dep_id
            });
        },
    },
    
    computed : {
        cur_tov_id () {
            if(this.doc.hasOwnProperty("tov_id")) {
                return this.doc.tov_id;
            }
            return null;
        },
        
        cur_dep_id() {
            if(this.doc.hasOwnProperty("dep_id")) {
                return this.doc.dep_id;
            }
            return null;
        },
        
        doc_rating: {
            get() {
                if (this.doc.hasOwnProperty("rating_id")) {
                    return this.doc.rating_id;
                }
                
                return 0;
            },
            set(val) {
                this.$emit('doc_change',{
                    'type' : 'rating_id',
                    'val'  : val
                });
            }
        },
        
        doc_comment : {
            get() {
                if (this.doc.hasOwnProperty("coment")) {
                    return this.doc.coment;
                }
                
                return "";
            },
            set(val) {
                this.$emit('doc_change',{
                    'type' : 'coment',
                    'val'  : val
                });
            }
        },
        
        
        rating_variants() {
            return [
                { text: 'плановий ремонт', value: 1 },
                { text: 'проведення ТО', value: 2 },
                { text: 'випуск техніки із МТС', value: 3 },
                { text: 'аварійний ремонт', value: 4 },
            ]
        },
        
    }
}
</script>


<style scoped>

</style>